<template>
	<div class="AddArticleMaster">
		<!-- <el-button
			icon="el-icon-arrow-left"
			type="warning"
			style="width:auto;"
			size="mini"
			@click="$router.go(-1)"
		>
			Previous Page
		</el-button> -->
		<div>
			<el-row :gutter="20" class="top-margin">
				<el-col :xl="6" :lg="6" :md="6" :sm="12" :xs="24">
					<p class="input-label">Applicable to all Stores?</p>
					<el-checkbox
						v-model="checked"
						style="display: block;height: 40px;margin-bottom: 20px;width: 100%;"
						:border="true"
						size="medium"
						true-label="all"
						false-label="none"
						@change="shownAlertMsg()"
					>
						<p v-if="checked == 'all'">
							&nbsp;&nbsp;Yes
						</p>
						<p v-if="checked == 'none'">
							&nbsp;&nbsp;&nbsp;No
						</p>
					</el-checkbox>
				</el-col>
				<el-col :xl="6" :lg="6" :md="6" :sm="12" :xs="24">
					<p class="input-label">If Not Select Location</p>
					<div>
						<el-select
							v-model="outletsSelected"
							class="custom-input"
							style="width: 100%;"
							:disabled="checked == 'all'"
							multiple
							filterable
							collapse-tags
							placeholder="Select"
						>
							<el-option
								v-for="(outlet, index) in outlets"
								:key="index"
								:label="outlet.name"
								:value="outlet.id"
							/>
						</el-select>
					</div>
				</el-col>
			</el-row>
		</div>
		<div>
			<BaseArticleMasterTable
				:key="articleMasterKey"
				:article-master="articleMaster"
				:add-ingredient="true"
				@createArticles="createArticles"
				@removeArticleFromList="removeArticle"
			/>
		</div>
	</div>
</template>

<script>
import { ArticleMasterMixin } from "../../../../../mixins/articleMaster.mixin";
import ArticleMasterService from "../../../../services/articleMasterService";
import CommonService from "../../../../services/commonService";
import { resolve } from "q";
export default {
	name: "AddArticleMaster",
	mixins: [ArticleMasterMixin],
	data() {
		return {
			checked: "all",
			outlets: [],
			outletsSelected: [],
			articleMaster: [],
			articleMasterKey: 0
		};
	},
	computed: {
		selectedOutletId: {
			get: function() {
				return this.checked == "all" ? this.checked : this.outletsSelected;
			},
			set: function(newValue) {
				this.checked = "all";
				this.outletsSelected = [];
			}
		},
		showLocationError() {
			return this.checked === "none" && this.outletsSelected.length === 0;
		}
	},
	watch: {
		checked: function(val) {
			if (val == "all") {
				this.outletsSelected = [];
			}
		}
	},
	methods: {
		removeArticle(index) {
			this.articleMaster.splice(index, 1);
		},
		async createArticles(articleMaster, departments) {
			const validationResult = await this.$validator
				.validateAll()
				.then(result => resolve(result));

			if (validationResult) {
				var sortedArticleMaster = await Promise.all(
					articleMaster.map(async article => {
						if (article.addNewDepartment) {
							// let departmentName = article.department;
							// article.department = {};
							try {
								article.department = await ArticleMasterService.createDepartment(
									{
										name: article.department
									}
								).then(response => {
									if (response.status === 201) {
										let data = JSON.parse(response.data);
										return resolve(data);
									}
								});
							} catch (err) {
								console.log("err");

								this.$notify.error({
									title: "Fail",
									message: `department creation failed in row ${article.id}`
								});
							}
						}
						if (article.addNewCategory) {
							try {
								article.category = await ArticleMasterService.createCategory({
									name: article.category,
									department: article.department.id
								}).then(response => {
									if (response.status === 201) {
										let data = JSON.parse(response.data);
										return resolve(data);
									}
								});
							} catch (err) {
								console.log("err");

								this.$notify.error({
									title: "Fail",
									message: `category creation failed in row ${article.id}`
								});
							}
						}
						if (article.addNewSubcategory) {
							try {
								article.subcategory = await ArticleMasterService.createSubCategory(
									{
										name: article.subcategory,
										category: article.category.id
									}
								).then(response => {
									if (response.status === 201) {
										let data = JSON.parse(response.data);
										return resolve(data);
									}
								});
							} catch (err) {
								console.log("err");

								this.$notify.error({
									title: "Fail",
									message: `subcategory creation failed in row ${article.id}`
								});
							}
						}

						return {
							code: article.itemCode,
							name: article.itemDescription,
							type: article.itemType,
							department: article.department.name,
							category: article.category.name,
							subcategory: article.subcategory.name,
							base_unit: article.baseUnit,
							remarks: article.productRemarks,
							default_cost: article.currentCost,
							order_unit: article.orderUnit,
							order_unit_conversion: article.containsEachBase,
							primary_shelf_life: article.primaryShelfLife,
							secondary_shelf_life: article.secondaryShelfLife,
							ordering_frequency: article.orderingFrequency,
							lead_time: article.leadTime,
							availability_type: article.availability_type,
							availability_type_start: article.availability_type_start,
							availability_type_end: article.availability_type_end,
							stock_comes_from: article.stockComesFrom,
							service_level: article.serviceLevel,
							status: article.status,
							min_stock_level: article.minStockLevel,
							forecast_type: article.forecastType,
							default_price: article.salesPrice
						};
					})
				);
				// console.log("sortedArticleMaster", sortedArticleMaster);
				this.createItems(sortedArticleMaster);
			}
		},
		async createItems(articles) {
			await ArticleMasterService.createArticleMaster({
				articles,
				...(this.checked === "none" && {
					outlets: this.selectedOutletId
				})
			})
				.then(response => {
					if (response.status === 200) {
						this.articleMaster = [];
						this.articleMasterKey += 1;
						this.$notify.success({
							title: "Success",
							message: "Items Created Succesfully"
						});
					}
				})
				.catch(err => {
					console.log(err);
					this.$notify.error({
						title: "Fail",
						message: "Item Creation Failed"
					});
				});
		},
		shownAlertMsg() {
			if (this.checked === "none") {
				this.$notify.error({
					title: "Warning",
					message: "Please select location.",
					type: "error"
				});
			}
		}
	}
};
</script>

<style lang="scss" scoped>
@import "./AddAticleMaster.scss";
</style>
